module.exports = __webpack_public_path__ + "static/media/img114.9f461c07.jpg";